module.exports = __webpack_public_path__ + "media/images/lb/902-aaa9fc712aabe737699d599df4df5bac.svg";